import React, { ElementType, FunctionComponent } from 'react';
import VolumeComponentProps from '../../../utils/props';
import useClasses from '../../../behaviors/use-classes/use-classes';

export interface CardTitleProps extends VolumeComponentProps {
  /**
   * ReactDom tag to use for the Card Title
   * @default 'div'
   */
  tag?: ElementType;
}

export const CardTitle: FunctionComponent<CardTitleProps> = ({
  children,
  className,
  tag: Tag = 'div',
  ...attributes
}: CardTitleProps) => {
  const baseClass = 'vol-card__title';
  const classes = useClasses({ baseClass, className });

  return (
    <Tag {...attributes} className={classes}>
      {children}
    </Tag>
  );
};

export default CardTitle;
